import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function StockMarketPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס שוק ההון',
        metaTitle: 'קורס שוק ההון ובורסה 2025 – איך לבחור נכון | Kursi',
        slug: 'stock-market',
        metaDescription: 'קורסי שוק ההון ובורסה 2025 – מסחר יומי, השקעות לטווח ארוך, ניתוח טכני. צ׳ק-ליסט ודגלים אדומים לפני רכישת קורס. קבלו 3 המלצות קורסים אישיות.',
        subtitle:
          'קורסי שוק ההון נבדלים ברמת הליווי, התרגול והסיכון. כאן תקבל מבנה ברור: איך לבחור, מה לבדוק, ומה להימנע ממנו.',
        chips: ['כולל צ׳ק-ליסט', 'דגלים אדומים', 'מתאים למתחילים/מתקדמים'],
        chatSeed: 'קורס שוק ההון',
        sections: [
          {
            id: 'goal',
            title: 'קודם מטרה, אחר כך קורס',
            body:
              'הטעות הכי יקרה: לבחור קורס לפני שמגדירים מטרה. מסחר יומי, סווינג, השקעות לטווח ארוך, ניתוח טכני/פונדמנטלי — זה עולמות שונים.',
            bullets: [
              'בחר יעד אחד: מסחר/השקעות',
              'האם יש לך זמן למסחר יומי בפועל?',
              'האם אתה רוצה שיטה + תרגול או תיאוריה?',
            ],
          },
          {
            id: 'practice',
            title: 'מה נחשב תרגול אמיתי בשוק ההון',
            body:
              'תרגול אמיתי זה לא “תראה סרטון”. זה תרגול מובנה עם משוב: תרחישים, ניהול סיכונים, ותהליך קבלת החלטות.',
            bullets: [
              'תרגול מסודר + משוב',
              'דגש על ניהול סיכונים (Stop, Risk/Reward)',
              'הבנה מה עושים “אחרי הקורס”',
            ],
          },
          {
            id: 'mentor',
            title: 'ליווי ומנטורינג',
            body:
              'אם אין ליווי/קהילה/מענה, רוב האנשים נתקעים אחרי שבועיים. תבדוק מראש איך נראית התמיכה ומה זמני תגובה.',
            bullets: ['מענה קבוע לשאלות', 'קהילה פעילה', 'פגישות/לייבים עם דוגמאות אמיתיות'],
          },
        ],
        checklist: [
          'יש תרגול + משוב (לא רק שיעורים)',
          'יש תוכנית לימודים ברורה לפי נושא/שבוע',
          'יש שקיפות: מי מלמד ומה הניסיון',
          'יש מדיניות ביטול/החזר הוגנת',
          'אין הבטחות לתשואה/רווח קבוע',
        ],
        redFlags: [
          '“רווח מובטח” או “תשואה חודשית קבועה”',
          'שיטה “סודית” בלי ניהול סיכונים',
          'דוחפים לסגור מהר בלי זמן לחשוב',
          'אין פירוט מה קורה אחרי הקורס',
        ],
        faq: [
          { q: 'מסחר או השקעות – מה עדיף?', a: 'תלוי זמן וסיבולת לסיכון. מסחר דורש נוכחות ומשמעת יומית. השקעות דורשות סבלנות ותוכנית.' },
          { q: 'האם צריך ניסיון קודם?', a: 'לא תמיד, אבל קורס טוב יאמר למי זה לא מתאים ויציע מסלול בסיס אם צריך.' },
          { q: 'כמה זמן עד שמרגישים ביטחון?', a: 'ביטחון מגיע מתרגול וחזרה. אם אין תרגול — אין תוצאות. צפה לתהליך של שבועות-חודשים, לא ימים.' },
        ],
      }}
    />
  );
}
